// extracted by mini-css-extract-plugin
export var changeIcon = "_7p-4";
export var container = "_7p-0";
export var divider = "_7p-7";
export var externalLinkIcon = "_7p-1";
export var green = "_7p-5";
export var helpCircleIcon = "_7p-3";
export var iconButton = "_7p-2";
export var red = "_7p-6";